import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import SectionHeading from './SectionHeading';
import { journeyStages } from '../lib/liveData';

export default function PerformanceIntelligence() {
  const [active, setActive] = useState(0);
  const s = journeyStages[active];
  return (
    <section id="performance" className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
      <SectionHeading
        eyebrow="Performance Intelligence"
        title={<span>Every Click Has a <span className="text-gradient">Story.</span></span>}
        subtitle="We map the complete customer journey — from first impression to lasting revenue — and optimize every stage with data."
      />

      {/* Funnel steps */}
      <div className="reveal glass-strong rounded-3xl p-6 md:p-8">
        <div className="flex flex-wrap items-center gap-2 md:gap-1">
          {journeyStages.map((stage, i) => (
            <React.Fragment key={stage.key}>
              <button
                onMouseEnter={() => setActive(i)}
                onClick={() => setActive(i)}
                className={`flex-1 min-w-[120px] rounded-2xl px-3 py-4 text-left transition-all ${active === i ? 'bg-gradient-to-br from-[#2563eb]/18 to-[#1d4ed8]/18 border border-[#2563eb]/40' : 'border border-slate-200 bg-slate-50 hover:border-slate-200'}`}
              >
                <div className="text-[10px] font-semibold tracking-wide uppercase text-slate-500">Stage {String(i + 1).padStart(2, '0')}</div>
                <div className={`font-display text-sm md:text-base font-semibold mt-1 ${active === i ? 'text-slate-900' : 'text-slate-600'}`}>{stage.label}</div>
                <div className={`font-display text-lg md:text-xl font-bold mt-1 ${active === i ? 'text-gradient-cyan' : 'text-slate-500'}`}>{stage.metric}</div>
              </button>
              {i < journeyStages.length - 1 && (
                <ArrowRight size={16} className="hidden md:block text-slate-600 shrink-0" />
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Active detail */}
        <div className="mt-6 grid md:grid-cols-3 gap-6 rounded-2xl border border-slate-200 bg-slate-50 p-6">
          <div>
            <div className="text-xs text-slate-500">{s.label}</div>
            <div className="font-display text-3xl font-bold text-slate-900 mt-1">{s.metric}</div>
            <div className="text-sm text-[#2563eb] mt-1">{s.sub}</div>
          </div>
          <div className="md:col-span-2 flex items-center">
            <p className="text-slate-600 leading-relaxed"><span className="text-slate-900 font-semibold">Optimization: </span>{s.action}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
